import React from 'react'
import { object, string } from 'prop-types'
import DateHelper from '../../../../../_plugins/lib/dateHelper.js'
import { locations } from '../../../../../config/generatedConfig.js'
import Modal from '../modal.jsx'

class PricesExplainedModalAllLocations extends React.Component {
  // Tech debt #181
  getProduct () {
    const { pageData: { productClass } } = this.props
    switch (productClass.toUpperCase()) {
      case 'CP':
        return {
          path: 'parking/',
          type: 'CP',
          configKey: 'carParking'
        }
      case 'HCP':
        return {
          path: 'hotels/',
          type: 'HCP',
          configKey: 'hotels'
        }
      case 'HO':
        return {
          path: 'hotels/',
          type: 'HO',
          configKey: 'hotels'
        }
    }

    return false
  }

  getPriceInformation (product) {
    try {
      const { prices } = require('../../../../../config/exports/buildTimeOnly/prices/' + product.path + 'allLocations.json')
      return prices
    } catch (e) {
      return false
    }
  }

  getLocationNames (product, priceInformation) {
    const data = {}
    if (product.type === 'CP') {
      if (locations[product.configKey].hasOwnProperty(priceInformation['per_day_location'])) data['dayLocation'] = locations[product.configKey][priceInformation['per_day_location']]
      if (locations[product.configKey].hasOwnProperty(priceInformation['per_week_location'])) data['weekLocation'] = locations[product.configKey][priceInformation['per_week_location']]
      return data
    }
    if (locations[product.configKey].hasOwnProperty(priceInformation['lowestDays0_location'])) data['dayLocation'] = locations[product.configKey][priceInformation['lowestDays0_location']]
    if (locations[product.configKey].hasOwnProperty(priceInformation['lowestDays8_location'])) data['weekLocation'] = locations[product.configKey][priceInformation['lowestDays8_location']]
    return data
  }

  convertIsoToEnglish (dateString) {
    if (!dateString) return ''
    const split = dateString.split('-')
    return split[2] + '/' + split[1] + '/' + split[0]
  }

  getContentForModal (locationNames, priceInformation, productType) {
    const info = {}
    let content
    if (productType === 'CP') {
      info.dateSearchWasMade = priceInformation.dateUsed.replace(/-/g, '/')
      info.startDate = priceInformation.startDate.replace(/-/g, '/')
      info.endDate = priceInformation.endDate.replace(/-/g, '/')
    } else {
      info.dateSearchWasMade = this.convertIsoToEnglish(priceInformation.lowestPriceDateSearchWasMade)
      info.startDate = this.convertIsoToEnglish(priceInformation.lowestPriceDateSearchedFor)
      info.endDate = this.convertIsoToEnglish(DateHelper.alterDateByNumberOfDays(DateHelper.parseIsoDate(priceInformation.lowestPriceDateSearchedFor), '+7').toISOString().split('T')[0])
    }

    const { dateSearchWasMade } = info
    const { dayLocation, weekLocation } = locationNames
    switch (productType) {
      case 'CP':
        content = (
          <div>
            <p>These prices refer to our cheapest airport parking products available.  The 'per day' price refers to the cheapest product available at { dayLocation } Airport and the 'per week' price refers to the cheapest product available at { weekLocation } Airport, both within the next 61 days, at 12am on { dateSearchWasMade }.</p>
            <p>Where we state a 'weekly' price, this is the total cost of this car parking for 8 days. The price per day refers to the same product and period, divided by 8.</p>
            <p>Please note: live prices are fluid and constantly changing according to availability and supplier pricing and, as such, may be different to the advertised price. It is intended as a guide price only, demonstrating the most accurate, cheapest price we anticipate being available today.</p>
          </div>
      )
        break
      case 'HO':
      case 'HCP':
        content = (
          <div>
            <p>These prices refer to our cheapest hotel and our cheapest hotel with parking package available.  The 'room only' price refers to the cheapest product available at { dayLocation } Airport and the '8 day' parking price refers to the cheapest product available at { weekLocation } Airport, both within the next 61 days, at 12am on { dateSearchWasMade }.</p>
            <p>Please note: live prices are fluid and constantly changing according to availability and supplier pricing and, as such, may be different to the advertised price. It is intended as a guide price only, demonstrating the most accurate, cheapest price we anticipate being available today.</p>
          </div>
      )
        break
    }

    return content
  }

  render () {
    const { id } = this.props
    const product = this.getProduct()
    let priceInformation = (product) ? this.getPriceInformation(product) : false
    if (!priceInformation || priceInformation.hasOwnProperty('error')) return null
    const locationNames = this.getLocationNames(product, priceInformation)
    return (
      <span id={id}>
        <a data-toggle='modal' data-target={'#' + product.type + 'PriceExplainedModalAllLocations'}>Our headline prices explained</a>
        <Modal id={product.type + 'PriceExplainedModalAllLocations'} heading={'From Prices Explained'} content={this.getContentForModal(locationNames, priceInformation, product.type)} />
      </span>
    )
  }
}

PricesExplainedModalAllLocations.propTypes = {
  id: string.isRequired,
  pageData: object
}

export default PricesExplainedModalAllLocations



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modals/PricesExplainedModalAllLocations.jsx